import Component from '../components/Main/Research'

let routes = {
    path: '/research',
    component: resolve => require(['../components/layout/SingleFunctionPage'], resolve),
    children: [
      {
          path: '/research/:id',
          name: 'Pesquisa',
          component: Component
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/research.js